module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/OpenSans-ExtraBoldItalic-webfont.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/OpenSans-ExtraBoldItalic-webfont.svg
// module id = 384
// module chunks = 0